let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9N8O3")).then(() => parcelRequire('gCID2'));